module.exports = __webpack_public_path__ + "img/ru_get.1b9cd02.png";